import React, { useState, useEffect } from 'react';

// use: 
//  const isDesktop = useIsDesktop();
function useIsDesktop() {
  const [isDesktop, setisDesktop] = useState();

  const handleWindowSizeChange = () => {
    const width = window.innerWidth;
    
    if (width > 1365) {
      setisDesktop(true);
    } else {
      setisDesktop(false);
    }
  }

  useEffect(() => {
    if (window.navigator !== "undefined") {
      window.addEventListener('resize', handleWindowSizeChange);
      return handleWindowSizeChange();
    } else  {
      // setisDesktop(false);
    }
    return () => {
      if (window.navigator !== "undefined") 
        window.removeEventListener('resize', handleWindowSizeChange);
    }
  }, []);

  return isDesktop;

}

export default useIsDesktop;